import React, { useEffect, useState } from "react";
import completedIcon from "../../assets/Icons/green-checkmark.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PopupModal from "../../common/PopupModal";
import CgDropdown from "../../common/CgDropdown";
import "./DashboardCards.scss";
import ProviderPhotos from "../providers/provider-info/ProviderPhotos";
import ProviderLicenseSection from "../providers/provider-info/ProviderLicenseSection";
import ProviderSpeciality from "../providers/provider-info/ProviderSpeciality";
import ProviderEducation from "../providers/experience/ProviderEducation";
import Association from "../providers/experience/Association";
import GeneralCertification from "../providers/experience/GeneralCertification";
import AddAgesTreated from "./AddAgesTreated";
import ProvidersDetails from "../practice/providers/ProvidersDetails";
import BrighterScorePopup from "./BrighterScorePopup";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardStats } from "../../store/dashboard/dashboardActions";
import defaultProfileImage from "../../assets/Icons/providerPlaceholder-icon.svg";
import {
  fetchBrighterScoreApi,
  fetchBrighterScoreCarrierApi,
} from "../../store/dashboard/BrighterScoreActions";

const DashboardCards = ({ streetAddress }) => {
  const [reviewBrighterScorePopup, setOpenReviewBrighterScorePopup] =
    useState(false);
  const [providersCardsData, setProvidersCardsData] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [openProviderPhotos, setOpenProviderPhotos] = useState(false);
  const [openDrivingLicense, setOpenDrivingLicense] = useState(false);
  const [openSpecialityPopup, setOpenSpecialityPopup] = useState(false);
  const [underGraduateDegreenPopup, setUnderGraduateDegreenPopup] =
    useState(false);
  const [openAssociationPopup, setOpenAssociationPopup] = useState(false);
  const [openCertificationsPopup, setOpenCertificationPopup] = useState(false);
  const [OpenAddAgesTreated, setOpenAddAgesTreated] = useState(false);
  const [addNewProvider, setAddNewProvider] = useState(false);
  const [
    openSecondReviewBrighterScorePopup,
    setOpenSecondReviewBrighterScorePopup,
  ] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [statsProviderData, setStatsProviderData] = useState(null);
  const [networkDropdownOptions, setNetworkDropdownOptions] = useState([]);
  const [showError, setShowError] = useState(false);
  const [selectedProvidersDetails, setSelectedProvidersDetails] = useState({});

  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const { dashboardStatsData } = useSelector((state) => state.dashboardStats);
  const { brighterScoreCarrierData, brighterScoreCarrierErrorMsg } =
    useSelector((state) => state.brighterScoreCarrierData);

  const generateProvidersSchemaData = () => {
    const generatedSchema = statsProviderData?.map((items) => {
      return {
        accessPointDisplayId: items?.accessPointDisplayId,
        displayId: items?.displayId,
        name: items?.name,
        brighterScore: items?.brighterScore,
        profilePhoto: items?.profilePhoto,
        handleProfilePhoto: () => {},
        completenessScore: items?.completenessScore,
        profilePhotoComplete: items?.profilePhotoComplete,
        handleProfilePhotoClick: (profilePhoto) => {
          console.log(profilePhoto);
        },
        licenseComplete: items?.licenseComplete,
        handleLicenseClick: () => {},
        specialtiesComplete: items?.specialtiesComplete,
        handleSpecialtyClick: () => {},
        undergraduateDegreeComplete: items?.undergraduateDegreeComplete,
        handleUndergraduateDegreeClick: () => {},
        dentalDegreeComplete: items?.dentalDegreeComplete,
        handleDentalMedicaldegreeClick: () => {},
        associationsComplete: items?.associationsComplete,
        handleAssociationsClick: () => {},
        certificationsComplete: items?.certificationsComplete,
        handleCertificationsClick: () => {},
        agesTreatedComplete: items?.agesTreatedComplete,
        handleAgesTreatedClick: () => {},
      };
    });

    return generatedSchema;
  };

  const handleProvidersData = (data) => {
    if (Array.isArray(data)) {
      return data;
    } else if (typeof data === Object || data !== null) {
      return [data];
    } else {
      return [];
    }
  };
  useEffect(() => {
    dispatch(fetchDashboardStats(practiceId));
  }, []);

  useEffect(() => {
    setStatsProviderData(handleProvidersData(dashboardStatsData?.providers));
  }, [dashboardStatsData]);

  useEffect(() => {
    if (statsProviderData?.length > 0) {
      const providersSchemaData = generateProvidersSchemaData();
      setProvidersCardsData(providersSchemaData);
    }
  }, [statsProviderData]);

  useEffect(() => {
    if (reviewBrighterScorePopup) {
      dispatch(
        fetchBrighterScoreCarrierApi({
          practiceId,
          providersId: selectedProvidersDetails?.displayId,
        })
      );
    }
  }, [reviewBrighterScorePopup]);

  useEffect(() => {
    if (
      brighterScoreCarrierData?.carriers &&
      brighterScoreCarrierData?.carriers.length > 0
    ) {
      const networkOptions = brighterScoreCarrierData?.carriers.map(
        (item, index) => {
          return {
            id: index,
            value: item,
          };
        }
      );
      setNetworkDropdownOptions(networkOptions);
    }
  }, [brighterScoreCarrierData]);

  useEffect(() => {
    if (brighterScoreCarrierErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [brighterScoreCarrierErrorMsg]);

  const handleSearch = async () => {
    await dispatch(
      fetchBrighterScoreApi({
        practiceId,
        providersId: selectedProvidersDetails?.displayId,
      })
    );
    setOpenReviewBrighterScorePopup(false);
    setOpenSecondReviewBrighterScorePopup(true);
  };

  const RenderBrighterCarrierError = () => {
    if (!showError) return null;
    return (
      <div
        className="overlay-alert alert alert-danger dashboardAlertTopPosition"
        role="alert"
      >
        {brighterScoreCarrierErrorMsg}
      </div>
    );
  };

  const RenderProvidersCards = () => {
    if (providersCardsData?.length < 1) return null;

    return (
      <div className="providersCardContainer">
        {providersCardsData?.length > 0 &&
          providersCardsData?.map((items, index) => {
            if (!items?.displayId) return null;
            return (
              <div className="providersCard" key={index}>
                <div className="cardHeader">
                  <div>
                    {items?.profilePhoto?.image[0]?.urlSmall ? (
                      <img
                        src={items?.profilePhoto?.image[0]?.urlSmall}
                        alt="Profile Image"
                        className="profileImage"
                        width={90}
                        height={90}
                        style={{
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div
                        className="addImageDiv"
                        onClick={() => {
                          setOpenProviderPhotos(true);
                          setEditingItem(items.displayId);
                        }}
                      >
                        <img
                          src={defaultProfileImage}
                          alt=""
                          height="50px"
                          width="50px"
                        />
                        <div>Add Photo</div>
                      </div>
                    )}
                  </div>
                  <div className="providersDetails">
                    <div className="dashboardProvidersName">{items?.name}</div>
                    <div className="brighterScore">
                      {items?.brighterScore === true ? (
                        <div
                          className="reviewText"
                          onClick={() => {
                            setSelectedProvidersDetails(items);
                            setOpenReviewBrighterScorePopup(true);
                          }}
                        >
                          Review Brighter Score
                        </div>
                      ) : (
                        <div className="scoreUnavailable">
                          <div>Brighter Score not available.</div>
                          <div>Call 424-316-2534</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="providersInformation">
                  <div className="providerInfoText">
                    Provider Information : {items?.completenessScore}%
                  </div>
                  <div className="providersProgressContainer">
                    <div
                      className="progressBar"
                      style={{ width: `${items?.completenessScore}%` }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div className="keyProfileElementsText">
                    Key Profile Elements
                    <Link
                      className="viewEdit"
                      to={`/provider/${items.displayId}/profile-information/info?fromPractice=${practiceId}`}
                    >
                      View/Edit All
                    </Link>
                  </div>
                  <div>
                    {items.profilePhotoComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenProviderPhotos(true);
                            setEditingItem(items.displayId);
                            // openProviderPhotos(true);
                            // items.handleProfilePhotoClick(true)
                          }}
                        >
                          Profile Photo
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => items.handleProfilePhotoClick(false)}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setOpenProviderPhotos(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenProviderPhotos(true);
                            setEditingItem(items.displayId);
                            // openProviderPhotos(true);
                            // items.handleProfilePhotoClick(true)
                          }}
                        >
                          Add a profile photo
                        </span>
                      </div>
                    )}
                    {items.licenseComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenDrivingLicense(true);
                            setEditingItem(items.displayId);
                            // items.handleLicenseClick(true)
                          }}
                        >
                          Dental license
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => {
                          setOpenDrivingLicense(true);
                          items.handleLicenseClick(false);
                        }}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setOpenDrivingLicense(true);
                            items.handleLicenseClick(false);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenDrivingLicense(true);
                            setEditingItem(items.displayId);
                            // items.handleLicenseClick(true)
                          }}
                        >
                          Add your dental license
                        </span>
                      </div>
                    )}
                    {items.specialtiesComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleSpecialtyClick(true)
                            setOpenSpecialityPopup(!openSpecialityPopup);
                            console.log("clicked on speciality");
                            setEditingItem(items.displayId);
                          }}
                        >
                          Specialty
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => items.handleSpecialtyClick(false)}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setOpenSpecialityPopup(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleSpecialtyClick(true)
                            setOpenSpecialityPopup(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          Add your specialty
                        </span>
                      </div>
                    )}
                    {items.undergraduateDegreeComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleUndergraduateDegreeClick(true)
                            setUnderGraduateDegreenPopup(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          Undergraduate degree
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() =>
                          items.handleUndergraduateDegreeClick(false)
                        }
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setEditingItem(items.displayId);
                            setUnderGraduateDegreenPopup(true);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleUndergraduateDegreeClick(true)
                            setEditingItem(items.displayId);
                            setUnderGraduateDegreenPopup(true);
                          }}
                        >
                          Add your undergraduate degree
                        </span>
                      </div>
                    )}
                    {items.dentalDegreeComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleDentalMedicaldegreeClick(true)
                            setEditingItem(items.displayId);
                            setUnderGraduateDegreenPopup(true);
                          }}
                        >
                          Dental/Medical degree
                        </span>
                      </div>
                    ) : (
                      <div className="keyProfileElementsList">
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setUnderGraduateDegreenPopup(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleDentalMedicaldegreeClick(true)
                            setUnderGraduateDegreenPopup(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          Add your dental or medical degree
                        </span>
                      </div>
                    )}
                    {items.associationsComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleAssociationsClick(true)
                            setEditingItem(items.displayId);
                            setTimeout(() => {
                              setOpenAssociationPopup(true);
                            }, 500);
                          }}
                        >
                          Associations
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => items.handleAssociationsClick(false)}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setEditingItem(items.displayId);
                            setTimeout(() => {
                              setOpenAssociationPopup(true);
                            }, 500);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleAssociationsClick(true)
                            setEditingItem(items.displayId);
                            setTimeout(() => {
                              setOpenAssociationPopup(true);
                            }, 500);
                          }}
                        >
                          Add your associations
                        </span>
                      </div>
                    )}
                    {items.certificationsComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleCertificationsClick(true)
                            setEditingItem(items.displayId);
                            setOpenCertificationPopup(true);
                          }}
                        >
                          Certifications
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => items.handleCertificationsClick(false)}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setEditingItem(items?.displayId);
                            setOpenCertificationPopup(true);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            // items.handleCertificationsClick(true)
                            setEditingItem(items?.displayId);
                            setOpenCertificationPopup(true);
                          }}
                        >
                          Add your Certifications
                        </span>
                      </div>
                    )}
                    {items.agesTreatedComplete === true ? (
                      <div className="keyProfileElementsList">
                        <img
                          alt=""
                          src={completedIcon}
                          width="20px"
                          height="16px"
                          className="checkmark"
                        />
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenAddAgesTreated(true);
                            // setEditingItem(items.accessPointDisplayId);
                            setEditingItem(items.displayId);
                            // dispatch(
                            //   practiceProvidersDetailsAPI({
                            //     practiceId: "AFVUWHEP28858753",
                            //     providerId: items.displayId,
                            //   })
                            // );
                            // items.handleAgesTreatedClick(true)
                          }}
                        >
                          Ages Treated
                        </span>
                      </div>
                    ) : (
                      <div
                        className="keyProfileElementsList"
                        onClick={() => items.handleAgesTreatedClick(false)}
                      >
                        <span
                          className="plus-circle"
                          onClick={() => {
                            setOpenAddAgesTreated(true);
                            setEditingItem(items.displayId);
                          }}
                        >
                          +
                        </span>
                        <span
                          className="item-text"
                          onClick={() => {
                            setOpenAddAgesTreated(true);
                            setEditingItem(items.displayId);
                            // dispatch(
                            //   practiceProvidersDetailsAPI({
                            //     practiceId: "AFVUWHEP28858753",
                            //     providerId: items.displayId,
                            //   })
                            // );
                            // items.handleAgesTreatedClick(true)
                          }}
                        >
                          Add your ages treated
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        <div
          className="addNewProviderContainer"
          onClick={() => {
            setAddNewProvider(true);
          }}
        >
          <img
            src={defaultProfileImage}
            alt="Add New Provider"
            height="50px"
            width="50px"
          />
          <p>Add New Provider</p>
          <span className="plusCircle">+</span>
        </div>
      </div>
    );
  };

  const RenderReviewBridhterScoreForm = () => {
    return (
      <div className="reviewBridhterScoreContainer">
        <h3>What is the Brighter Score?</h3>
        <p>
          The Brighter Score is designed to help patients find great providers
          that meet their long-term dental needs. Brighter developed the
          methodology based on extensive patient and provider research, as well
          as collaboration with dental associations and industry leaders.
        </p>
        <p>{`The Brighter Score is calculated based on information published on a provider's profile. This information
                    is collected directly from providers, as well as state licensing boards, patients, and carriers.`}</p>
        <p>
          Your Brighter Score varies by office location, network, and carrier.
          Please choose from your contracted carriers below that have partnered
          with Brighter to help connect members and network providers.
        </p>
        <p>
          Brighter is committed to helping you improve your Brighter Score and
          attract new patients. If you have any questions or need any help,
          please
          <a
            className="contactUsLink"
            onClick={() => {
              navigateTo("/contactus");
            }}
            style={{ marginLeft: "4px" }}
          >
            contact us.
          </a>
        </p>

        <div className="selectNetworkContainer">
          <div className="selectedNetworkLabel">Select Network :</div>
          <CgDropdown
            dropdownOptions={networkDropdownOptions}
            dropdownPlaceHolder="Select..."
            onSelectCallBack={(name, value) => {
              setSelectedNetwork(value);
            }}
            name="network"
            dropdownClassName="selectNetworkDropdown"
          />
          <button
            className={`searchNetworkBtn ${!selectedNetwork ? "disabled" : ""}`}
            // disabled={!selectedNetwork ? true : false}
            onClick={() => handleSearch()}
          >
            Go
          </button>
        </div>
      </div>
    );
  };

  const RenderProvidersPopup = () => {
    return (
      <div>
        <PopupModal
          isOpen={reviewBrighterScorePopup}
          onClose={() =>
            setOpenReviewBrighterScorePopup(!reviewBrighterScorePopup)
          }
          customRender={RenderReviewBridhterScoreForm}
          width="83%"
        />
      </div>
    );
  };

  return (
    <>
      {RenderBrighterCarrierError()}
      {RenderProvidersCards()}
      {RenderProvidersPopup()}
      {openSecondReviewBrighterScorePopup && (
        <>
          <BrighterScorePopup
            openPopupModal={openSecondReviewBrighterScorePopup}
            closePopupCallBack={() => {
              setOpenSecondReviewBrighterScorePopup(false);
            }}
            providerId={selectedProvidersDetails?.displayId}
            streetAddress={streetAddress}
            selectedProvidersDetails={selectedProvidersDetails}
            carrier={selectedNetwork}
          />
        </>
      )}
      {openProviderPhotos && (
        <>
          <ProviderPhotos
            providerId={editingItem}
            onlyPopup={true}
            closePopupCallback={() => {
              setTimeout(() => {
                dispatch(fetchDashboardStats(practiceId));
                setOpenProviderPhotos(false);
                setEditingItem(null);
              }, 500);
            }}
            openProviderPhotos={openProviderPhotos}
          />
        </>
      )}
      {openDrivingLicense && (
        <>
          <ProviderLicenseSection
            providerId={editingItem}
            onlyPopup={true}
            closePopupCallback={() => {
              console.log("called license");
              dispatch(fetchDashboardStats(practiceId));
              setOpenDrivingLicense(false);
              setEditingItem(null);
            }}
            openAddLicensePopup={openDrivingLicense}
          />
        </>
      )}
      {openSpecialityPopup && (
        <>
          <ProviderSpeciality
            providerId={editingItem}
            onlyPopup={true}
            closePopupCallback={() => {
              console.log("ProviderSpeciality", openAssociationPopup);
              dispatch(fetchDashboardStats(practiceId));
              setOpenSpecialityPopup(false);
              setEditingItem(null);
            }}
            openSpecialityPopup={openSpecialityPopup}
          />
        </>
      )}
      {underGraduateDegreenPopup && (
        <>
          <ProviderEducation
            providerId={editingItem}
            openEducationPopup={underGraduateDegreenPopup}
            onlyPopup={true}
            closePopupCallback={() => {
              dispatch(fetchDashboardStats(practiceId));
              setUnderGraduateDegreenPopup(false);
              setEditingItem(null);
            }}
          />
        </>
      )}
      {openAssociationPopup && (
        <>
          <Association
            providerId={editingItem}
            onlyPopup={true}
            openAssociationPopup={openAssociationPopup}
            closePopupCallback={() => {
              dispatch(fetchDashboardStats(practiceId));
              setOpenAssociationPopup(false);
              setEditingItem(null);
            }}
          />
        </>
      )}
      {openCertificationsPopup && (
        <>
          <GeneralCertification
            providerId={editingItem}
            onlyPopup={true}
            openCertificationPopup={openCertificationsPopup}
            closePopupCallback={() => {
              dispatch(fetchDashboardStats(practiceId));
              setOpenCertificationPopup(false);
              setEditingItem(null);
            }}
          />
        </>
      )}
      {OpenAddAgesTreated && (
        <>
          {/* accessPointDisplayId */}
          <AddAgesTreated
            providerId={editingItem}
            practiceId={practiceId}
            openPopupModal={OpenAddAgesTreated}
            closePopupCallBack={() => {
              dispatch(fetchDashboardStats(practiceId));
              setOpenAddAgesTreated(false);
              setEditingItem(null);
            }}
          />
        </>
      )}
      {addNewProvider && (
        <>
          <ProvidersDetails
            providerId={editingItem}
            onlyPopup={true}
            openProvidersDetailsPopup={addNewProvider}
            closePopupCallback={() => {
              dispatch(fetchDashboardStats(practiceId));
              setAddNewProvider(false);
              setEditingItem(null);
            }}
          />
        </>
      )}
    </>
  );
};

export default DashboardCards;
